import { render, staticRenderFns } from "./invite-user-list.vue?vue&type=template&id=52f60534&scoped=true&"
import script from "./invite-user-list.vue?vue&type=script&lang=js&"
export * from "./invite-user-list.vue?vue&type=script&lang=js&"
import style0 from "./invite-user-list.vue?vue&type=style&index=0&id=52f60534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f60534",
  null
  
)

export default component.exports